<template>
  <div class="upload-avatar">
    <a-upload
        name="file"
        list-type="picture-card"
        :action="`${axios.defaults.baseURL}/biz/infocollect/uploadImg`"
        :before-upload="beforeUpload"
        :data="getUploadData"
        @change="handleChange(formData, $event)"
        :file-list="fileList"
        :showUploadList="false"
        :headers="headers"
        :disabled="!edit"
        accept=".jpg,.png,.jpeg"
    >
      <div v-if="formData.type == 'headPic'">
        <img v-if="!formData.url" src="../../../../static/images/nan.jpg" alt="avatar" style="width:135px;height: 146px;"/>
        <img v-else :src="formData.url" alt="avatar" style="width:135px;height: 146px;"/>
      </div>
      <div v-else>
        <div v-if="!formData.url">
          <a-icon type="plus"/>
          <div style="margin-top: 8px">Upload</div>
        </div>
        <div v-else class="img-container">
          <img :src="formData.url" alt="img" />
        </div>
      </div>
    </a-upload>
  </div>
</template>

<script>
export default {
  name: 'JImageUpload',
  data() {
    return {
      uploadLoading: false,
      imgType: '', // 上传图片类型
      aspectRatio: '', // 图片上传规则
      picUrl: false,
      edit: true,
      headers: {'X-Access-Token': localStorage.getItem('token')}
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    fileList: {
      type: Array,
      required: false
    }
  },
  watch: {
    'formData.edit': {
      handler(val) {
        this.edit = val
      },
      deep: true,
      immediate: true
    },
    'formData.label': {
      handler(val) {
        if (val && val.includes('身份证') > 0) {
          this.imgType = 'IDCard'
          this.aspectRatio = 'width > height'
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getUploadData(file) {
      return {
        imgType: this.imgType || '' // 图片类型，如身份证
      }
    },
    beforeUpload: function(file) {
      this.fileList = []
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.error('请上传图片')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 // 判断文件大小是否超过10MB
      if (isLt2M > 10) {
        this.$message.error('图片大小不能超过10MB')
        return false
      }
      // 添加图片长宽校验（支持自定义长宽比要求）
      return new Promise((resolve, reject) => {
        // 检查是否为图片文件
        if (!file.type.startsWith('image/')) {
          resolve(true)
          return
        }

        const imgRule = this.aspectRatio || ''
        // 获取长宽比要求
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = new Image()
          img.onload = () => {
            let isValid = false
            let errorMsg = ''
            // 根据不同的长宽比要求进行校验
            let imgHeight = img.height
            let imgWidth = img.width
            if (imgRule) {
              switch (imgRule) {
                case 'height>width':
                  isValid = imgHeight > imgWidth
                  errorMsg = '图片高度必须大于宽度，请上传竖向拍摄的证件照'
                  break
                case 'width>height':
                  isValid = imgWidth > imgHeight
                  errorMsg = '图片宽度必须大于高度，请上传横向拍摄的图片'
                  break
                case 'square':
                  // 允许一定的误差范围（±5%）
                  const ratio = imgWidth / imgHeight
                  isValid = ratio >= 0.95 && ratio <= 1.05
                  errorMsg = '图片必须是正方形'
                  break
                default:
                  // 自定义比例，如 "16:9"
                  if (imgRule.includes(':')) {
                    const [targetWidth, targetHeight] = imgRule.split(':').map(Number)
                    const actualRatio = imgWidth / imgHeight
                    const targetRatio = targetWidth / targetHeight
                    // 允许5%的误差
                    isValid = Math.abs(actualRatio - targetRatio) / targetRatio <= 0.05
                    errorMsg = `图片长宽比必须是${targetWidth}:${targetHeight}`
                  } else {
                    // 默认情况下不进行长宽比校验
                    isValid = true
                  }
              }
            } else {
              isValid = true
            }
            if (isValid) {
              resolve(true)
            } else {
              this.$message.error(errorMsg)
              reject(false)
            }
          }
          img.onerror = () => {
            this.$message.error('图片加载失败，请重新选择')
            reject(false)
          }
          img.src = e.target.result
        }
        reader.onerror = () => {
          this.$message.error('文件读取失败，请重新选择')
          reject(false)
        }
        reader.readAsDataURL(file)
      })
    },
    handleChange(code, info) {
      let fileList = info.fileList
      if (info.file.status === 'done') {
        let resData = info.file.response
        if (resData.success) {
          fileList = fileList.map(file => {
            if (file.response) {
              file.url = file.response.message
            }
            return file
          })
          this.$message.success(`${info.file.name} 上传成功!`)
          this.$emit('change', info.file)
          this.$emit('getPath', resData.result)
        } else {
          this.$message.error(`${info.file.name} 上传失败，失败原因：${resData.message}`, 2)
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
        this.$emit('change', '')
      }
      this.fileList = fileList
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style scoped lang="css">
.upload-avatar >>> .ant-upload {
  padding: 0;
}
.img-container img {
  max-width: 300px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/components/JImageUpload.vue